import React from 'react';
import { useIntl } from 'react-intl';
import gql from 'graphql-tag';
import StorageMartNav from 'components/StorageMartNav';
import useQuery from '../../../modules/react/hooks/useQuery';

const GET_NAVIGATION_DATA = gql`
  query GetStorageMartSiteNavigation($locale: String!) {
    currentSite {
      companyId
      id
      navigation(locale: $locale) {
        id
        text
        page {
          id
          ...NavigationItemPageFields
        }
        ...NavigationItems
      }
    }
  }

  ${StorageMartNav.fragments.page}
  ${StorageMartNav.fragments.navigationItem}
`;

const Navigation = ({ ...rest }) => {
  const { locale } = useIntl();
  const { data } = useQuery(GET_NAVIGATION_DATA, { variables: { locale } });

  if (!data) {
    return <StorageMartNav />;
  }

  const { currentSite: { navigation } } = data;
  return <StorageMartNav navigation={navigation} {...rest} />;
};

export default Navigation;
